/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Selected_EventsInputs */

const en_bold_selected_events = /** @type {(inputs: Bold_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bold selected events`)
};

const fr_bold_selected_events = /** @type {(inputs: Bold_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre en gras les événements sélectionnés`)
};

const de_bold_selected_events = /** @type {(inputs: Bold_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählte Ereignisse (fett hervorgehoben)`)
};

const it_bold_selected_events = /** @type {(inputs: Bold_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventi selezionati in grassetto`)
};

const ru_bold_selected_events = /** @type {(inputs: Bold_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выделенные события`)
};

const es_bold_selected_events = /** @type {(inputs: Bold_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos seleccionados en negrita`)
};

const zh_cn2_bold_selected_events = /** @type {(inputs: Bold_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粗体显示的是选定的事件`)
};

const ja_bold_selected_events = /** @type {(inputs: Bold_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントを太字で表示`)
};

const hi_bold_selected_events = /** @type {(inputs: Bold_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चुनिंदा घटनाओं को बोल्ड करें`)
};

const pt_pt2_bold_selected_events = /** @type {(inputs: Bold_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos selecionados em negrito`)
};

/**
* | output |
* | --- |
* | "Bold selected events" |
*
* @param {Bold_Selected_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const bold_selected_events = /** @type {((inputs?: Bold_Selected_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Selected_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_bold_selected_events(inputs)
	if (locale === "de") return de_bold_selected_events(inputs)
	if (locale === "it") return it_bold_selected_events(inputs)
	if (locale === "ru") return ru_bold_selected_events(inputs)
	if (locale === "es") return es_bold_selected_events(inputs)
	if (locale === "zh-CN") return zh_cn2_bold_selected_events(inputs)
	if (locale === "ja") return ja_bold_selected_events(inputs)
	if (locale === "hi") return hi_bold_selected_events(inputs)
	if (locale === "pt-PT") return pt_pt2_bold_selected_events(inputs)
	return en_bold_selected_events(inputs)
});